import axios from 'axios';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';
import Metadata from '../helpers/metadata/Metadata';
import serviceUtil from './serviceUtil';

let helpers = {
  getBuild(buildId, options) {
    let encodedFilter = '';
    if (options && options.recordDescriptor) {
      //added this for now so we can descriminate between old and new calls
      encodedFilter = recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'get',
      url:
        process.env.REACT_APP_API +
        '/builds/' +
        buildId +
        '?current_company=' +
        localStorage.current_company_id +
        '&filtering=' + encodedFilter,
      timeout: 60000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  },
  getBuildsByIds(buildIds, options) {
    let request =  process.env.REACT_APP_API + '/builds?current_company=' + localStorage.current_company_id; 
    
    if (options && options.recordDescriptor) {
      //added this for now so we can descriminate between old and new calls
      request += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    request += buildIds ? '&build_ids=' + buildIds.join() : '';

    return axios({
      method: 'get',
      url: request,
      timeout: 60000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
      });
  },
  reorderBuilds(reorderPairs, project, projectTemplate) {
    let data = { reorder_list: reorderPairs };
    if (project) {
      data.project_id = project.id;
    }
    else if (projectTemplate) {
      data.project_template_id = projectTemplate.id;
    }
    let encodedFilter = recordDescriptorProcessing.getEncodedForFastSerializer({
      project: {
        builds: {
        },
      },
    });

    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API + '/builds/reorder_builds?current_company=' + localStorage.current_company_id +
        '&filtering=' + encodedFilter,
      data,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },  
  createBuild(build, eventMetadatum, options) {
    const ancestries = build.ancestry.split
      ? build.ancestry.split('/')
      : build.ancestry;
    const parent_id = ancestries.length
      ? ancestries[ancestries.length - 1]
      : ancestries;
    delete build.ancestry;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url:
        process.env.REACT_APP_API +
        '/builds/' +
        parent_id +
        '?current_company=' +
        localStorage.current_company_id,
      data: {
        eventMetadatum: eventMetadatum,
        build: build,
      },
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  updateBuild(build, eventMetadatum, options) {
    build.location_id = build.location ? build.location.id : build.location_id;
    delete build.project;
    delete build.location;
    delete build.builds;
    delete build.ancestry;
    delete build.completion_percentage;
    delete build.builds_count;
    delete build.builds_count;
    delete build.created_by;
    delete build.parent;
    delete build.user_build_assignments;
    delete build.tasks;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url:
        process.env.REACT_APP_API +
        '/builds/' +
        build.id +
        '?current_company=' +
        localStorage.current_company_id,
      data: {
        eventMetadatum: eventMetadatum,
        build: build,
      },
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  copyBuild(build, build_changedName, selectedTasks) {
    let url = process.env.REACT_APP_API + '/builds/' + build.id + '/copy?&current_company=' + localStorage.current_company_id;
    let requestBody = { ...build_changedName };
    if (selectedTasks && selectedTasks.length > 0) {
      const task_ids = selectedTasks.map(selectedTask => selectedTask);
      requestBody = { ...requestBody, task_ids };
    }
    return axios({
      method: 'post',
      url: url,
      data: {
        build: requestBody,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });

  },
  deleteBuild(build_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url:
        process.env.REACT_APP_API +
        '/builds/' +
        build_id +
        '?current_company=' +
        localStorage.current_company_id,
      timeout: 60000,
      data: {
        eventMetadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return { status: 'success' };
      })
      .catch(error => {
        return { error: error };
      });
  },
  createNotify(build, project, notify, eventMetadatum) {
    delete build.toBeAdded;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url:
        process.env.REACT_APP_API +
        '/builds/' +
        build.id +
        '/notify?current_company=' +
        localStorage.current_company_id,
      data: {
        eventMetadatum: eventMetadatum,
        user: {   id: notify.user.id },
        project: { id: project.id },
      },
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  deleteNotify(build, notify, eventMetadatum) {
    delete build.toBeDeleted;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url:
        process.env.REACT_APP_API +
        '/builds/' +
        build.id +
        '/remove_notify?current_company=' +
        localStorage.current_company_id,
      data: {
        eventMetadatum: eventMetadatum,
        user: {   id: notify.user.id },
      },
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  createBuildOwner(build, project, owner, eventMetadatum) {
    delete build.toBeAdded;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url:
        process.env.REACT_APP_API +
        '/builds/' +
        build.id +
        '/build_owner?current_company=' +
        localStorage.current_company_id,
      data: {
        eventMetadatum: eventMetadatum,
        user: {   id: owner.user_id },
        project: { id: project.id },
      },
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  deleteBuildOwner(build, owner, eventMetadatum) {
    delete build.toBeDeleted;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url:
        process.env.REACT_APP_API +
        '/builds/' +
        build.id +
        '/remove_build_owner?current_company=' +
        localStorage.current_company_id,
      data: {
        eventMetadatum: eventMetadatum,
        user: {   id: owner.user_id },
      },
      timeout: 60000,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  bulkAssign(bulkAssign) {
    const eventMetadatum = Metadata.generateMetadatum();
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/builds/bulk_assign?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        bulk_assign: bulkAssign,
      },
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return { error: error };
    });
  },

};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/buildsService.js